import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectOrgHierarchyRootOrg } from '../../../store/selectors/orgHierarchy.selectors';
import OrgHierarchyChildren from './OrgHierarchyChildren';
import CreateOrgModal from './CreateOrgModal';
import { Organization } from '../../models/organization';
import { selectUserProfile } from '../../../store/selectors/profile.selectors';
import { UserRoles } from '../../models/user';

interface OrgHierarchyProps {
  filterQuery: string;
}

const OrgHierarchy = (props: OrgHierarchyProps) => {
  const { filterQuery } = props;
  const rootOrg = useSelector(selectOrgHierarchyRootOrg);
  const user = useSelector(selectUserProfile);
  const [showCreateOrgModal, setShowCreateOrgModal] = useState(false);
  const [createOrgParent, setCreateOrgParent] = useState(null);

  const openCreateOrgModalHandler = (parent: Organization) => {
    setCreateOrgParent(parent);
    setShowCreateOrgModal(true)
  };

  return (
    <div id="orgHierarchy" className="glympse-orgHierarchy-modal-body-inner">
      <div className="glympse-orgHierarchy-root-container">
        <CreateOrgModal
          show={showCreateOrgModal}
          onClose={() => setShowCreateOrgModal(false)}
          parent={createOrgParent}
        />
        <OrgHierarchyChildren
          orgs={rootOrg ? [rootOrg] : []}
          root
          creatable={user?.roles?.indexOf(UserRoles.Admin) > -1 && rootOrg?.tags?.indexOf('orgHierarchy:create-new') > -1}
          parent={rootOrg}
          onOpenCreateOrgModal={openCreateOrgModalHandler}
          filterQuery={filterQuery}
        />
      </div>
    </div>
  )
};

export default OrgHierarchy;
